import { render, staticRenderFns } from "./examText.vue?vue&type=template&id=75121270&scoped=true"
import script from "./examText.vue?vue&type=script&lang=js"
export * from "./examText.vue?vue&type=script&lang=js"
import style0 from "./examText.vue?vue&type=style&index=0&id=75121270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75121270",
  null
  
)

export default component.exports